import React from 'react';
import { useDispatch } from 'react-redux';
import cx from 'classnames';

import { makeStyles } from '@material-ui/core/styles';

import StaffingInputFilter from 'components/Staffing/Contractors/StaffingInputFilter/StaffingInputFilter';
import { setDealsFilterPayload } from 'redux/actions/staffingActions';
import { useStaffingSelector } from 'redux/selectors/staffing/staffingSelectors';

const useStyles = makeStyles(theme => ({
  main: {
    display: 'flex',
    flexWrap: 'wrap',
    marginBottom: 25,
  },
  search: {
    width: 280,
    // Room for the floating label above the grey field without clipping.
    paddingTop: 16,
    [theme.breakpoints.down('xs')]: {
      width: '100%',
    },
  },
  // StaffingInputFilter defaults to 8px FormControl margin; that would sit the
  // field inset from the company cards, whose grid cells use 10px horizontal padding.
  searchControl: {
    margin: 0,
  },
}));

/**
 * Client-side name search for the Companies list. Uses the same underlined Input as
 * other staffing filters (not a filled TextField) so the chrome matches PickerSelect.
 */
const CompaniesFilter = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { companiesSearch } = useStaffingSelector();

  return (
    <div className={cx(classes.main)}>
      <div className={classes.search}>
        <StaffingInputFilter
          label="Search companies"
          name="companiesSearch"
          value={companiesSearch || ''}
          formControlClassName={classes.searchControl}
          onChange={event => {
            dispatch(setDealsFilterPayload({ companiesSearch: event.target.value }));
          }}
        />
      </div>
    </div>
  );
};

export default CompaniesFilter;
